var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"sidebarItem tickFilter",class:{ticked: _vm.ticked},on:{"click":_vm.onclick}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.ticked}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }